import React from 'react';
import PropTypes from 'prop-types';
import LandingPageAboutSection from '../../../../components/LandingPageAboutSection';

export default function AboutSection({ content, backgroundImage }) {
  const parsedContent = content.split('\n\n');

  return <LandingPageAboutSection content={parsedContent} backgroundImage={backgroundImage} />;
}

AboutSection.propTypes = {
  content: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string,
};

AboutSection.defaultProps = {
  backgroundImage: undefined,
};
